import { Typography, makeStyles, Grid } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { Icon, VerticalDivider } from "../../../../components/base";

const useStyles = makeStyles((theme) => ({
  root: {
    border: "1px solid rgba(33, 33, 33, 0.1)",
    borderRadius: "8px",
    boxShadow: "0px 12px 26px rgba(33, 33, 33, 0.06)",
    cursor: "pointer",
    backgroundColor: COLORS.white,
    height: (props) => props.height,
    padding: "16px 24px",
  },
  label: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
    lineHeight: "20px",
    textTransform: "uppercase",
    letterSpacing: "0.2px",
  },
  dividerContainer: {
    height: "100%",
    margin: "0px 16px",
  },
}));

export const IconLabelButton = ({ iconSrc, height, children }) => {
  const classes = useStyles({ height });

  return (
    <Grid container className={classes.root} alignItems="center" wrap="nowrap">
      <Grid item>
        <Icon src={iconSrc} />
      </Grid>
      <Grid item className={classes.dividerContainer}>
        <VerticalDivider height="100%" flexAlignment="center" containerHeight="100%" />
      </Grid>
      <Grid item>
        <Typography variant="h5" className={classes.label}>
          {children}
        </Typography>
      </Grid>
    </Grid>
  );
};
